import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useContext } from "react";
import { ModuleRatingsContext } from "../../module-ratings.context";

export const ModuleRatingsTableFilters = () => {
	const { state, setState } = useContext(ModuleRatingsContext);

	return (
		<div className={"flex gap-2"}>
			<InputText
				className="m-1 w-21rem"
				type={"number"}
				value={state.from + ""}
				onChange={(e) => {
					const num = +e.currentTarget.value;

					setState({
						...state,
						from: num,
					});
				}}
				placeholder={"Score von"}
			/>
			<InputText
				className="m-1 w-21rem"
				type={"number"}
				value={state.to + ""}
				onChange={(e) => {
					const num = +e.currentTarget.value;

					setState({
						...state,
						to: num,
					});
				}}
				placeholder={"Score bis"}
			/>
			<Button
				icon={"pi pi-times"}
				onClick={() => {
					setState(() => ({}));
				}}
			/>
		</div>
	);
};
